import styled from "styled-components";


export const StyledText = styled.h3`

  color: var(--color-purple);
  font-size: 0.9rem;
  text-transform: uppercase;
  font-weight: 700
`